<template>
  <div class="classic-form-page">
    <mdb-navbar
      style="background-color: transparent !important; box-shadow: 0 0 0 0;"
      position="top"
      :toggler="false"
      dark
    >
      <mdb-navbar-brand
        href="/"
        class="mt-2 mb-2"
      >
        <img
          :src="require('@/assets/logo2.png')"
          class="mr-2"
          alt="HospizWare Logo"
        />
        <strong>HospizWare APP</strong>
      </mdb-navbar-brand>
    </mdb-navbar>
    <mdb-view>
      <mdb-mask
        overlay="black-light"
        class="d-flex justify-content-center align-items-center"
      >
        <mdb-container>
          <mdb-row>
            <div class="col-xl-5 col-lg-6 col-md-10 col-sm-12 mx-auto mt-5">
              <mdb-card id="classic-card">
                <mdb-card-body class="z-depth-2 ">
                  <div class="form-header blue-gradient">
                    <h5 class="mb-0"><i class="fas fa-user mt-2 mb-2 mr-2"></i>Anmeldung</h5>
                  </div>
                  <validation-observer v-slot="{ handleSubmit }">
                    <form novalidate @submit.prevent="handleSubmit(authenticate)">
                      <validation-provider
                        name="Benutzername"
                        rules="required"
                        v-slot="{ errors, valid, validated }"
                        slim
                      >
                        <mdb-input
                          v-model="form.Benutzer"
                          label="Benutzername"
                          name="Benutzername"
                          icon="envelope"
                          iconClass="special-color-text"
                          :customValidation="validated"
                          :isValid="valid"
                          :invalidFeedback="errors[0]"
                          validFeedback="sieht gut aus"
                          outline
                        />
                      </validation-provider>
                      <validation-provider
                        name="Passwort"
                        rules="required"
                        v-slot="{ errors, valid, validated }"
                        slim
                      >
                        <mdb-input
                          v-model="form.Passwort"
                          label="Passwort"
                          icon="key"
                          type="password"
                          iconClass="special-color-text"
                          :customValidation="validated"
                          :isValid="valid"
                          :invalidFeedback="errors[0]"
                          validFeedback="sieht gut aus"
                          outline
                        />
                      </validation-provider>
                      <div class="text-center mt-4 black-text">
                        <mdb-btn
                          color="primary"
                          type="submit"
                          :disabled="loading"
                        >
                          <template v-if="!loading">
                            Login <mdb-icon icon="sign-in-alt" />
                          </template>
                          <template v-else>
                            <span
                              class="spinner-grow spinner-grow-sm"
                              role="status"
                              aria-hidden="true"
                            />
                            Verladung
                          </template>
                        </mdb-btn>
                      </div>
                    </form>
                  </validation-observer>
                </mdb-card-body>
              </mdb-card>
            </div>
          </mdb-row>
        </mdb-container>
      </mdb-mask>
    </mdb-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  mdbView,
  mdbMask,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbInput,
  mdbContainer,
  mdbRow,
  mdbIcon,
  mdbNavbarBrand,
  mdbNavbar,
} from "mdbvue";

export default {
  name: "Login",
  components: {
    mdbView,
    mdbMask,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbContainer,
    mdbRow,
    mdbIcon,
    mdbNavbarBrand,
    mdbNavbar
  },
  data() {
    return {
      loading: false,
      form: {
        Benutzer: '',
        Passwort: ''
      },
      rooms: []
    }
  },

  created() {
    this.loadRooms()
    this.setTimer()
  },

  methods: {
    ...mapActions('auth', ['setUser']),
    ...mapActions('auth', ['setRoomDialog']),

    loadRooms () {
      this.$http.get('Dashboard')
        .then(res => {
          this.rooms = res.data.data
        })
    },

    setTimer () {
      this.$http.get('/Einstellung')
        .then(res => {
          localStorage.setItem('timeout_overview', res.data.timeout_overview)
          localStorage.setItem('timeout_room', res.data.timeout_room)
        })
        .catch((error) => {
          console.log(error)
        })
    },

    authenticate () {
      // @TODO Implement Authentication Request
      this.loading = true
      this.$http.post('Authentifizierung', this.form)
        .then(res => {
          let user = res.data
          if(res.data.Token) {
            user.username = this.form.Benutzer
            this.setUser(user)
            localStorage.setItem('access_token', user.Token)
            localStorage.setItem('loginUSer',JSON.stringify(user))
            this.$http.defaults.headers.common['csToken'] = `${user.Token}`
            this.$notify.success({message: 'Anmeldung erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})

            let settingsRoom = parseInt(localStorage.getItem('settingsRoom'))

            if (!isNaN(settingsRoom)) {
              let roomdetails = null
              this.rooms.find(room => {
                if (room.Id === settingsRoom) {
                  roomdetails = room
                }
              })

              let data = []
              this.rooms.forEach(room => {
                data.push({
                  'name': room.Zimmer,
                  'status': true
                })
              })
              this.setRoomDialog(data)

              localStorage.setItem('room', JSON.stringify(roomdetails))
              localStorage.setItem('roomID', roomdetails.Id)
              localStorage.setItem('dialog_open', roomdetails.Zimmer)

              this.$router.push({ path: `/pflegebericht/${settingsRoom}` })
            } else {
              this.$router.push({ path: '/Zimmerübersicht' })
            }
          }else {
            this.$notify.error({message: user.Message, position: 'top right', closeButton: false, timeOut: 5000})
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.classic-form-page {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
  height: 100vh;
  width: 100%;
}

.classic-form-page .view {
  background-image: url("../assets/site-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 100vh;
}


.classic-form-page h6 {
  line-height: 1.7;
}

.classic-form-page .navbar {
  transition: background 0.5s ease-in-out, padding 0.5s ease-in-out;
}

.classic-form-page .navbar .md-form {
  margin: 0;
}

.top-nav-collapse {
  background: #424f95 !important;
}

@media (max-width: 768px) {
  .classic-form-page .navbar:not(.top-nav-collapse) {
    background: #424f95 !important;
  }
}

.classic-form-page label {
  color: #fff !important;
}
</style>
